import { render, staticRenderFns } from "./alertsTable.vue?vue&type=template&id=0c829b04&scoped=true"
import script from "./alertsTable.vue?vue&type=script&lang=js"
export * from "./alertsTable.vue?vue&type=script&lang=js"
import style0 from "./alertsTable.vue?vue&type=style&index=0&id=0c829b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c829b04",
  null
  
)

export default component.exports